import { trialRoundDates, mainRoundDates } from '@app/components/shared/StateLabel/Label'

const RulesEN = (event) => {
  return (
     `
      <h3 class="info-about-static__pre-title"><b>DinoMath Olympiad: Guide for Students, Parents, and Teachers</b></h3>
      <h4 class="info-about-static__pre-title"><b>Welcome to the DinoMath Olympiad!</b></h4>
      <p class="info-about-static__text">
      <ul>
        <li>The DinoMath Olympiad is a free online competition for Grade 1-8 students. 
         This interactive event, developed by DinoLab specialists, offers a series of mind-bending puzzles and 
         riddles designed to enhance logical thinking skills. Students can participate from the comfort of their 
         homes or schools using a phone, tablet, or PC with a stable internet connection.        
        </li>
      </ul>
      </p>
      <br/>
      <h3 class="info-about-static__pre-title"><b>Why Join the DinoMath Olympiad?</b></h3>
      <p class="info-about-static__text">
      <ul>
        <li><b>&#x2022; Engaging Challenges</b>: Solve unique, practical tasks that foster logical reasoning.</li>
        <li><b>&#x2022; Accessibility</b>: Free and open to every student, focused on general skills. Olympiad tasks do not require specific school knowledge.</li>
        <li><b>&#x2022; National Recognition</b>: Compete against students nationwide and earn recognition for your achievements.</li>
        <li><b>&#x2022; Rewards</b>: Receive certificates of achievement based on your performance.</li>
			</ul>
      </p>
      <br/>
      <h3 class="info-about-static__pre-title"><b>How to Join the DinoMath Olympiad</b></h3><br/>
      <h4 class="info-about-static__pre-title"><b>For Teachers:</b></h4>
      <ul>
        <li><b>1. Announce the Event</b>: Inform your students about the Olympiad and encourage them to participate. Display the <a href="/poster-IN-en.pdf" target="_blank">Olympiad poster</a> in your classroom.</li>
        <li><b>2. Track Progress</b>: Monitor student success through the Reports section on the Olympiad page.</li>
        <li><b>3. Promote Participation</b>: Use posters and share links via group chats to remind students of the Olympiad stages and deadlines. Every teacher who invites students to participate in the Olympiad will receive a Certificate of Appreciation</li>
      </ul>
      <br/>
      <h4 class="info-about-static__pre-title"><b>For Students:</b></h4>
      <ul>
        <li><b>1. Participate</b>: Log in during the competition dates and start solving tasks to compete.</li>
      </ul>
      <br/>
      <h3 class="info-about-static__pre-title"><b>Stages of the DinoMath Olympiad</b></h3>
      <p class="info-about-static__text">
      <ul>
        <li><b>&#x2022; Warm-Up Stage</b> (August 15 – September 30): Students can complete sample challenges and practice tasks to prepare for the main event.</li>
        <li><b>&#x2022; DinoMath Olympiad</b> (October 01 – November 30): The main competition will run for three weeks. Participants will have one try and 60 minutes to complete the Olympiad in one sitting.</li>
        <li><b>&#x2022; Final Round</b> (December 01 – February 28): During this period, the students who have scored the best in the previous round will be able to participate in quizzes with children from different schools in India.</li>
        <li><b>&#x2022; Trophies & Rewards</b> (March): Check the overall rankings and correct answers. Print and distribute certificates of achievement and appreciation letters.</li>
			</ul> 
      </p>
      <br/>
      <h3 class="info-about-static__pre-title"><b>Frequently Asked Questions (FAQ)</b></h3>
      <ul>
        <li><b>&#x2022; What is the DinoMath Olympiad?</b> The DinoMath Olympiad is an online competition with interactive challenges to develop student problem-solving and critical thinking skills.</li>
        <li><b>&#x2022; Who can participate?</b> Students from Grades 1 to 8.</li>
        <li><b>&#x2022; Is there a fee?</b> No, the DinoMath Olympiad is completely free.</li>
        <li><b>&#x2022; What do I need to participate?</b> A DinoLab account, a stable internet connection, and a device (phone, tablet, or PC) using a supported browser (preferably <a href="https://www.google.com/chrome/index.html" target="_blank">Chrome</a>).</li>
        <li><b>&#x2022; When does the Olympiad take place?</b> The competition is divided into stages: Warm-Up (August 15 – September 30), DinoMath Olympiad (October 01 – November 30), Final Round (December 01 – February 28) and Trophies & Rewards.</li>
        <li><b>&#x2022; How much time is given for the Olympiad?</b> You will have one try and 60 minutes to complete the Olympiad in one sitting.</li>
        <li><b>&#x2022; What if there’s a technical issue?</b> Contact DinoLab Support at <a href="mailto:support@dinolab.com">support@dinolab.com</a> with your Student ID for assistance.</li>
        <li><b>&#x2022; Are there rewards?</b> Yes, participants will receive certificates of achievement based on their scores.</li>
        <li><b>&#x2022; When will I get my certificate?</b> Certificates will be available within one week after the Olympiad in the Certificates Section of your Profile.</li>
        <li><b>&#x2022; Will there be more Olympiads?</b> Yes, this is just the beginning of an exciting journey!</li>
	  </ul>
	  <br/>
      <h3 class="info-about-static__pre-title"><b>Organizing the Olympiad in Your School</b></h3>
      <br/>
      <h4 class="info-about-static__pre-title"><b>During the Warm-Up Stage (August 15 – September 30):</b></h4>
      <ul>
        <li>&#x2022; Share links to new tasks and challenges available on the website.</li>
      </ul>
      <br/>
      <h4 class="info-about-static__pre-title"><b>During the DinoMath Olympiad:</b></h4>
      <ul>
        <li>&#x2022; Share the Olympiad link with students.</li>
        <li>&#x2022; Monitor student success through the Reports section on the website.</li>
      </ul>
      <br/>
      <h4 class="info-about-static__pre-title"><b>During Trophies & Rewards Stage:</b></h4>
      <ul>
        <li>&#x2022; Check student rankings and correct answers when available.</li>
        <li>&#x2022; Print and distribute certificates of achievement and appreciation letters.</li>
        <li>&#x2022; Every teacher who invites students to participate in the Olympiad will receive a Certificate of Appreciation.</li>
      </ul>
    `
  )
}

export default RulesEN
